function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { computed, defineComponent, onMounted, ref, watch, getCurrentInstance } from "vue";
// @ts-ignore
import { Uploader, UploaderBtn } from "./vue-simple-uploader.js";
import { v2Host } from "@/config/host";
import { getApiPath } from "@/common/api-proxy";
import { getToken } from "@/utils/auth";
import _ from "lodash";
import { getFileExtension, getFileName } from "@com/utils/file";
import FileTypes from "@/config/file-types";
import { isWindowOSBrowser } from "@com/utils/os";
import { AssetFileStatus } from "@com/components/asset-uploader/uploader.type";
import { unzip } from "@com/utils/zip-file";
import { archiveTypes } from "@/config/file-types";
import { checkAssets, createAssets } from "@pt/api/assets";
import { Message } from "element-ui";
import { t } from "@/lang";
// @ts-ignore
import Worker from "@/file.worker";
import { isMd5 } from "@com/utils/md5";
import { readAsArrayBuffer } from "@com/utils/file-reader";
import SparkMD5 from "spark-md5";
export default defineComponent({
    props: {
        options: Object,
        autoStart: {
            type: Boolean,
            default: false
        },
        // 上传文件类型， 数组类型，如 ['mp4', 'png']
        accepts: {
            type: Array,
            default: function() {
                return Object.keys(FileTypes);
            }
        },
        maxSize: {
            type: Number,
            default: 1 * 1024 * 1024
        },
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        /**
     * 上传文件类型
     * zip 压缩包
     * dragonbone 龙骨
     * seqframe 序列帧
     * font 字体
     * ...
     *  */ type: {
            type: String,
            default: undefined
        },
        skeletonType: {
            type: Number,
            default: undefined
        },
        beforeUpload: {
            type: Function
        },
        singleFile: Boolean
    },
    components: {
        Uploader: Uploader,
        UploaderBtn: UploaderBtn
    },
    setup: function setup(props, param1) {
        var emit = param1.emit;
        var handleFilesAdded = function handleFilesAdded(files) {
            emit("files-added", files);
        };
        var validateFileTrue = function validateFileTrue(file) {
            emit("file-added", file);
            setLoadingToTrue();
            // check Md5和zip文件
            handleCheckFile(file);
            sysnFileLists(UploaderInstance.value.fileList);
        };
        var errorHandle = // 上传的zip文件验证不通过的处理
        function errorHandle(file, errorMsg) {
            // setLoadingToFalse()
            var fileExtraProp = fileExtraList.value.find(function(f) {
                return f.id === file.id;
            });
            root.$message.warning(errorMsg);
            fileExtraProp.status = AssetFileStatus.uploadAlready;
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var uploaderBtn = ref();
        var uploaderBtnAttr = computed(function() {
            var accept = "";
            var allowIntercept = function() {
                // 已知在 macos 自定义拦截不准确的类型
                var disableTypes = [
                    "mkv"
                ];
                // window 平台通过 allowMediaTypes 做自定义拦截不准确
                // mac 平台对于 mkv 这种格式，无法获取元素类型，因此统一不做拦截，后置过滤
                if (props.accepts && props.accepts.length && !isWindowOSBrowser() && _.intersection(props.accepts, disableTypes).length === 0) {
                    return true;
                }
                return false;
            };
            if (allowIntercept()) {
                accept = props.accepts.map(function(key) {
                    // @ts-ignore
                    if (FileTypes[key] && FileTypes[key].mediaTypes) {
                        // @ts-ignore
                        return FileTypes[key].mediaTypes;
                    }
                    return [];
                }).flat().join();
            }
            return {
                attrs: {
                    accept: accept
                }
            };
        });
        // 为什么要监听，因为 UploadBtn 不支持动态修改 accept 属性，需要重新获取 dom 去修改属性
        // https://github.com/simple-uploader/vue-uploader/issues/80
        watch(function() {
            return props.accepts;
        }, function(newValue, oldValue) {
            if (newValue.join() !== oldValue.join()) {
                if (uploaderBtn.value && uploaderBtn.value.$el && uploaderBtn.value.$el.querySelector("input[type=file]")) {
                    var input = uploaderBtn.value.$el.querySelector("input[type=file]");
                    input.setAttribute("accept", uploaderBtnAttr.value.attrs.accept);
                }
            }
        });
        var uploader = ref();
        var setLoadingToTrue = function() {
            if (props.loading) {
                return;
            }
            emit("update:loading", true);
        };
        var setLoadingToFalse = function() {
            if (!props.loading) {
                return;
            }
            emit("update:loading", false);
        };
        var generateExtraProp = function(file) {
            return {
                id: file.id,
                size: file.size,
                name: file.name,
                errorMsg: "",
                file_url: "",
                progress: 0,
                md5: "",
                status: AssetFileStatus.waiting
            };
        };
        var fileList = ref([]);
        // 为什么要有这个额外的 fileExtraList， 因为 fileList 里面的 file 是 UploaderFile 类型，没有扩展的属性
        var fileExtraList = ref([]);
        var sysnFileLists = function(files) {
            fileList.value = files;
            fileList.value.forEach(function(file) {
                if (!fileExtraList.value.find(function(f) {
                    return f.id === file.id;
                })) {
                    fileExtraList.value.push(generateExtraProp(file));
                }
            });
        };
        var updateFileExtraProp = function(param) {
            var id = param.id, data = param.data;
            var fileExtra = fileExtraList.value.find(function(f) {
                return f.id === id;
            });
            if (fileExtra) {
                Object.assign(fileExtra, data);
            }
        };
        // 清除所有正在上传的文件
        var clearAllFile = function() {
            fileList.value = [];
            fileExtraList.value = [];
        };
        // 删除正在上传的文件
        var removeFile = function(file) {
            fileList.value.splice(fileList.value.findIndex(function(item) {
                return item.id === file.id;
            }), 1);
            fileExtraList.value.splice(fileExtraList.value.findIndex(function(item) {
                return item.id === file.id;
            }), 1);
        };
        // 校验文件Md5和名称
        var checkAssetsIsValid = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(id, file) {
                var fileExtraProp, res, asset_id, name_valid, checkName;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (file) file.id = id;
                            fileExtraProp = fileExtraList.value.find(function(f) {
                                return f.id === id;
                            });
                            if (!(fileExtraProp && fileExtraProp.status === AssetFileStatus.waiting)) {
                                _ctx.next = 19;
                                break;
                            }
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return checkAssets({
                                check_name: true,
                                file_md5: fileExtraProp.md5,
                                name: getFileName(fileExtraProp.name, true),
                                format: getFileExtension(fileExtraProp.name),
                                size: fileExtraProp.size
                            });
                        case 6:
                            res = _ctx.sent;
                            asset_id = _.get(res, "data.data.id") // 资产库id,如果md5校验存在，则有该数据，否则没有
                            ;
                            name_valid = _.get(res, "data.data.name_valid") // 名称校验结果，true表示名称不存在，false表示名称已存在
                            ;
                            checkName = _.get(res, "data.data.name") + "." + _.get(res, "data.data.format");
                            if (!asset_id) {
                                fileExtraProp.status = AssetFileStatus.uploadStart;
                                if (!name_valid) {
                                    Message.warning(t("basic.upload.renamedTip"));
                                }
                            } else {
                                Message.warning(t("basic.upload.successfully", {
                                    checkName: checkName
                                }));
                                fileExtraProp.status = AssetFileStatus.uploadAlready;
                                emit("already", file);
                            }
                            emit("checkAssets", {
                                id: asset_id,
                                file_id: fileExtraProp.id
                            });
                            _ctx.next = 19;
                            break;
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](3);
                            emit("remove-file", {
                                id: fileExtraProp.id
                            });
                            fileExtraProp.status = AssetFileStatus.uploadError;
                            Message.error(_ctx.t0.message);
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        14
                    ]
                ]);
            }));
            return function checkAssetsIsValid(id, file) {
                return _ref.apply(this, arguments);
            };
        }();
        var createAssetsByFileId = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(id) {
                var fileExtra, params, res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            fileExtra = fileExtraList.value.find(function(f) {
                                return f.id === id;
                            });
                            _ctx.prev = 1;
                            if (!fileExtra.file_url) {
                                _ctx.next = 10;
                                break;
                            }
                            params = {
                                name: getFileName(fileExtra.name, true),
                                file_url: fileExtra.file_url,
                                auto_rename: 1
                            };
                            if (props.type === "model") {
                                params.creative_type = "3d_model";
                                params.skeleton_type = props.skeletonType;
                            }
                            _ctx.next = 7;
                            return createAssets(params);
                        case 7:
                            res = _ctx.sent;
                            if (res.data.code === 0) {
                                fileExtra.status = AssetFileStatus.uploadSuccess;
                            } else {
                                fileExtra.status = AssetFileStatus.uploadError;
                            }
                            return _ctx.abrupt("return", res.data.data.id);
                        case 10:
                            return _ctx.abrupt("return", "");
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](1);
                            fileExtra.status = AssetFileStatus.uploadError;
                            console.warn(_ctx.t0);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        13
                    ]
                ]);
            }));
            return function createAssetsByFileId(id) {
                return _ref.apply(this, arguments);
            };
        }();
        var UploaderInstance = computed(function() {
            if (uploader.value) {
                return uploader.value.uploader;
            }
            return null;
        });
        var innerOptions = _objectSpread({
            singleFile: props.singleFile,
            target: "".concat(v2Host).concat(getApiPath("/upload/file")),
            chunkSize: 6 * 1024 * 1024,
            maxChunkRetries: 3,
            testChunks: true,
            testMethod: "POST",
            uploadMethod: "POST",
            query: {
                bucket: "mws-files",
                mod: "assets"
            },
            headers: {
                "Auth-Token": getToken()
            },
            // 服务器分片校验函数，秒传及断点续传基础
            checkChunkUploadedByResponse: function(chunk, response) {
                var res = {};
                var showErrorMessage = function(msg) {
                    root.$message({
                        message: msg || root.$t("basic.apiError"),
                        type: "error"
                    });
                };
                try {
                    res = JSON.parse(response);
                } catch (e) {
                    showErrorMessage();
                    throw new Error(// @ts-ignore
                    (e && (e === null || e === void 0 ? void 0 : e.message)) || "JSON.parse \u53D1\u751F\u9519\u8BEF\uFF0C\u63A5\u53E3\u8FD4\u56DE\u6570\u636E\u4E0D\u662F\u5408\u6CD5\u7684 JSON");
                }
                console.log("checkChunkUploadedByResponse: ", res);
                var code = Number(res.code);
                if (code !== 0) {
                    showErrorMessage(res.msg);
                    // 这里抛出错误是为了让 vue-simple-uploader 认为这里发生了错误
                    // 直接返回 false 或不返回，组件会继续执行代码（如只有一个分块的时候，会认为这个已经上传成功了，触发成功回调函数更新UI为成功状态），导致 UI 上展示不正确
                    throw new Error(res.message || "\u629B\u51FA\u4E00\u4E2A\u9519\u8BEF");
                }
                // 上传完成
                if (code === 0 && _.get(res, "data.file.is_completed")) {
                    return true;
                }
                // res.upload_chunks = [2, 3, 4, 5, 6, 8, 10, 11, 12, 13, 17, 20, 21]
                // 检查分块是否已经上传过了
                var uploadChunks = _.get(res, "data.file.upload_chunks") || [];
                console.log("\u68C0\u67E5\u5206\u5757\u662F\u5426\u5DF2\u7ECF\u4E0A\u4F20\u8FC7\u4E86: ", uploadChunks.indexOf(chunk.offset + 1) >= 0);
                return uploadChunks.indexOf(chunk.offset + 1) >= 0;
            },
            processParams: function processParams(params) {
                // 将属性名改成 snakeCase，兼容后端接口的数据规范
                return _.mapKeys(params, function(value, key) {
                    return _.snakeCase(key);
                });
            }
        }, props.options);
        var worker = ref(null);
        var isSupportWorker = function() {
            return typeof Worker !== "undefined";
        };
        var updateStateAfterComputedMD5 = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(file, md5) {
                var fileItem, fileExtraProp;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            fileItem = fileList.value.find(function(item) {
                                return item.name === file.name && item.size === file.size && // @ts-ignore
                                !isMd5(item.uniqueIdentifier);
                            });
                            fileExtraProp = fileExtraList.value.find(function(item) {
                                return item.name === file.name && item.size === file.size && !isMd5(item.md5);
                            });
                            if (!(fileItem && fileExtraProp)) {
                                _ctx.next = 10;
                                break;
                            }
                            // @ts-ignore
                            fileItem.uniqueIdentifier = md5;
                            fileExtraProp.md5 = md5;
                            _ctx.next = 7;
                            return checkAssetsIsValid(fileItem.id, file);
                        case 7:
                            if (fileExtraProp.status === AssetFileStatus.uploadStart) {
                                fileItem.resume();
                            }
                            _ctx.next = 11;
                            break;
                        case 10:
                            {
                                console.error("\u4E0A\u4F20\u7684\u8D44\u6E90\u5217\u8868\u4E0D\u542B\u8BE5\u8D44\u6E90");
                            }
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function updateStateAfterComputedMD5(file, md5) {
                return _ref.apply(this, arguments);
            };
        }();
        var computeMD5 = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(file) {
                var time, buffer, md5;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            time = new Date().getTime();
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return readAsArrayBuffer(file);
                        case 4:
                            buffer = _ctx.sent;
                            md5 = SparkMD5.ArrayBuffer.hash(buffer);
                            updateStateAfterComputedMD5(file, md5);
                            console.log("MD5\u8BA1\u7B97\u5B8C\u6BD5\uFF1A".concat(file.name, " MD5\uFF1A").concat(md5, " \u7528\u65F6\uFF1A").concat(new Date().getTime() - time, " ms"));
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](1);
                            console.error(_ctx.t0);
                            // @ts-ignore
                            Message.error(_ctx.t0.message);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        10
                    ]
                ]);
            }));
            return function computeMD5(file) {
                return _ref.apply(this, arguments);
            };
        }();
        var handleWorkerMessage = function(event) {
            if (event.data.error) {
                Message.error(event.data.error.message || "Web Worker \u5904\u7406\u6587\u4EF6\u53D1\u751F\u9519\u8BEF\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5\u6216\u8054\u7CFB\u5F00\u53D1\u8005");
                return;
            }
            if (event.data.type === "calculate-md5" && event.data.md5 && event.data.file) {
                updateStateAfterComputedMD5(event.data.file, event.data.md5);
            }
        };
        var validateFileType = function(file) {
            var ext = getFileExtension(file.name).toLowerCase();
            // @ts-ignore
            if (props.accepts.map(function(accept) {
                return accept.toLowerCase();
            }).includes(ext)) {
                return true;
            }
            // @ts-ignore
            root.$message.error(root.$t("basic.upload.fileStatus.invalidType"));
            return false;
        };
        var validateFileSize = function(file) {
            if (file.size > props.maxSize) {
                setTimeout(function() {
                    // @ts-ignore
                    root.$message({
                        message: root.$t("basic.upload.fileStatus.warningMaxSize", {
                            size: props.maxSize / 1024 / 1024
                        }),
                        type: "error"
                    });
                }, 0);
                return false;
            }
            return true;
        };
        var validateFile = function(file) {
            return validateFileSize(file) && validateFileType(file);
        };
        var handleCheckFile = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(file) {
                var params, resZip;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(archiveTypes.zip.mediaTypes.indexOf(file.fileType) !== -1)) {
                                _ctx.next = 13;
                                break;
                            }
                            params = props.type === "model" ? {
                                file_type: "3DModel",
                                skeleton_type: props.skeletonType
                            } : undefined;
                            _ctx.next = 4;
                            return unzip(file, params);
                        case 4:
                            resZip = _ctx.sent;
                            if (!(props.type && resZip.type !== props.type)) {
                                _ctx.next = 10;
                                break;
                            }
                            errorHandle(file, root.$t("basic.upload.fileStatus.invalidType"));
                            return _ctx.abrupt("return");
                        case 10:
                            if (resZip.valid) {
                                _ctx.next = 13;
                                break;
                            }
                            errorHandle(file, resZip.message);
                            return _ctx.abrupt("return");
                        case 13:
                            if (isSupportWorker() && worker.value) {
                                // @ts-ignore
                                worker.value.postMessage({
                                    type: "calculate-md5",
                                    file: file.file
                                }) // 派发事件给 web woker
                                ;
                            } else {
                                computeMD5(file.file);
                            }
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function handleCheckFile(file) {
                return _ref.apply(this, arguments);
            };
        }();
        var handleFileAdded = function(file) {
            if (props.beforeUpload) {
                props.beforeUpload(file).then(function(options) {
                    if (options.check && validateFile(file)) {
                        validateFileTrue(file);
                    } else {
                        if (!options.check && options.message) {
                            root.$message.warning(options.message);
                        }
                        emit("remove-file", file);
                        file.ignored = true;
                    }
                });
            } else {
                if (validateFile(file)) {
                    validateFileTrue(file);
                } else {
                    file.ignored = true;
                }
            }
        };
        // 一个文件上传成功事件，第一个参数 rootFile 就是成功上传的文件所属的根 Uploader.File 对象，它应该包含或者等于成功上传文件；第二个参数 file 就是当前成功的
        var handleFileSuccess = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(rootFile, file, response) {
                var res, uploadUnCompleted, code, assetId;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            res = {};
                            try {
                                res = JSON.parse(response);
                            } catch (error) {
                                res = {};
                            }
                            uploadUnCompleted = function() {
                                updateFileExtraProp({
                                    id: file.id,
                                    data: {
                                        errorMsg: res.msg
                                    }
                                });
                                setLoadingToFalse();
                                root.$message({
                                    message: res.msg,
                                    type: "error"
                                });
                            };
                            code = Number(res.code);
                            if (!(code === 0 && _.get(res, "data.file.is_completed"))) {
                                _ctx.next = 13;
                                break;
                            }
                            updateFileExtraProp({
                                id: file.id,
                                data: {
                                    file_url: _.get(res, "data.file.object_key")
                                }
                            });
                            _ctx.next = 8;
                            return createAssetsByFileId(file.id);
                        case 8:
                            assetId = _ctx.sent;
                            emit("uploadComplete", {
                                id: assetId,
                                file_id: file.id
                            });
                            if (fileExtraList.value.every(function(item) {
                                return item.status === AssetFileStatus.uploadSuccess;
                            })) {
                                setLoadingToFalse();
                            }
                            _ctx.next = 14;
                            break;
                        case 13:
                            if (code === 1) {
                                uploadUnCompleted();
                            }
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function handleFileSuccess(rootFile, file, response) {
                return _ref.apply(this, arguments);
            };
        }();
        /**
     * 创建队列结束之后，回调 emit 事件
     */ var handleUploadComplete = function() {
            setTimeout(function() {
                if (fileExtraList.value.some(function(item) {
                    return item.status === AssetFileStatus.uploading;
                })) {
                    handleUploadComplete();
                } else {
                    // setLoadingToFalse()
                    // emit('uploadComplete')
                    setTimeout(function() {
                        if (UploaderInstance.value) {
                            UploaderInstance.value.cancel();
                            clearAllFile();
                        }
                    }, 1000);
                }
            }, 300);
        };
        // 上传进度事件
        var handleFileProgress = function(rootFile, file, chunk) {
            setLoadingToTrue();
            updateFileExtraProp({
                id: file.id,
                data: {
                    progress: file.progress(),
                    status: AssetFileStatus.uploading
                }
            });
            emit("file-progress", {
                id: file.id,
                progress: file.progress()
            });
            console.log("\u4E0A\u4F20\u8FDB\u5EA6", file.id, file.progress());
            console.log("\u4E0A\u4F20\u4E2D ".concat(file.name, "\uFF0Cchunk\uFF1A").concat(chunk.startByte / 1024 / 1024, " ~ ").concat(chunk.endByte / 1024 / 1024));
        };
        watch(function() {
            return fileExtraList.value;
        }, function(array) {
            if (array.length) {
                // 资源已存在或接口报错取消loading
                var alreadyAsset = array.find(function(item) {
                    return item.status === AssetFileStatus.uploadAlready || item.status === AssetFileStatus.uploadError;
                });
                if (alreadyAsset) {
                    setLoadingToFalse();
                    removeFile(alreadyAsset);
                // uploadComplete(alreadyAsset.id, alreadyAsset)
                }
            }
        }, {
            deep: true
        });
        onMounted(function() {
            worker.value = new Worker();
            // @ts-ignore
            worker.value.addEventListener("message", handleWorkerMessage);
        });
        return {
            uploaderBtn: uploaderBtn,
            uploaderBtnAttr: uploaderBtnAttr,
            uploader: uploader,
            innerOptions: innerOptions,
            handleFileAdded: handleFileAdded,
            handleFilesAdded: handleFilesAdded,
            handleFileSuccess: handleFileSuccess,
            handleFileProgress: handleFileProgress,
            handleUploadComplete: handleUploadComplete,
            removeFile: removeFile
        };
    }
});
